// Add this import at the top of your file
import { css } from "@emotion/react";
import { MoonLoader } from "react-spinners";
// If you're using styled-components, you can alternatively use:
// import { css } from 'styled-components';

// Add the override style before the LoadingOverlay component
const override = css`
  display: block;
  margin: 0 auto;
`;

// Loading overlay component
export const LoadingOverlay = () => (
  <div className="loader-container d-flex align-items-center">
    <div className="modal-backdrop show"></div>
    <div className="row mx-auto custom-loader-css">
      <div className="col-12 d-flex justify-content-center mb-5">
        <MoonLoader css={override} size={80} color={'#8c1c4d'} loading={true} />
      </div>
      <div className="col-12 text-center">
        <h4 className="color-wine">Checking available appointment times...</h4>
      </div>
    </div>
  </div>
);
export const staffAvailability={
    "id": 1,
    "category_id": 157,
    "service_id": 826,
    "staff_id": 49935,
    "serviceObjData": {
        "id": 826,
        "position": 827,
        "salon_id": 166,
        "category_id": 157,
        "resource_id": null,
        "tax_id": null,
        "name": "Brighten Me Up Facial",
        "description": "Brighten, hydrate and give skin a radiant glow with this potent NeoBright Facial Treatment. Resurfacing enzymes work to unify the complexion and reduce the appearance of dark spots. Skin is smoothed, radiant and protected from free-radicals.",
        "duration": "60",
        "padding_time": "15",
        "color": "",
        "service_booked_online": 1,
        "deposit_booked_online": 0,
        "deposit_booked_price": "0.00",
        "hide_service_booking_widget": 0,
        "voucher_online": 1,
        "isNotId": 0,
        "add_on_services_count": 1,
        "serviceprice": [
            {
                "id": 913,
                "price": "140.00",
                "add_on_price": "0.00",
                "is_active": 1,
                "is_active_at": "2023-10-05T04:00:28.000000Z",
                "created_at": "2023-08-24T09:56:37.000000Z",
                "updated_at": "2024-03-19T22:26:04.000000Z",
                "add_on_services_count": 1,
                "pricetier": {
                    "id": 136,
                    "salon_id": 166,
                    "name": "General",
                    "description": null,
                    "is_active": 1,
                    "is_active_at": "2023-08-23T12:07:26.000000Z",
                    "created_at": "2023-08-23T09:37:26.000000Z",
                    "updated_at": "2023-08-23T09:37:26.000000Z",
                    "is_default": 1,
                    "totalStaff": 9
                }
            }
        ]
    },
    "staffObjData": null,
    "datetime": "",
    "totalprice": 0,
    "duration": "01:00",
    "padding_time": "00:15",
    "durationWithPadding": "01:15",
    "parentAppointmentEndTime": "",
    "resource_item_id": "",
    "resource_name": "",
    "appointment_id": "",
    "busytime_id": "",
    "dateof": "2024-11-26 14:40:00",
    "start_datetime": "2024-11-26 00:00:00",
    "listview": "Appointment",
    "salon_id": 166,
    "uid": "173227323640726733",
    "page_type": "BookingLink",
    "formType": "bookingwidget/staff/view",
    "categories": [
        {
            "category_id": 157,
            "category_name": "Facials",
            "treatments": [
                {
                    "treatment_id": 827,
                    "treatment_name": "Clear My Complexion Facial",
                    "staff_id": 49935,
                    "staff_name": "china coyle",
                    "price": "140.00"
                },
                {
                    "treatment_id": 828,
                    "treatment_name": "Defend My Resilience Facial",
                    "staff_id": null,
                    "staff_name": "Any available staff",
                    "price": "0.00"
                },
                {
                    "treatment_id": 829,
                    "treatment_name": "Defend My Resilience Facial",
                    "staff_id": 49935,
                    "staff_name": "Any available staff",
                    "price": "0.00"
                }
            ]
        }
    ]
}
